import { createFrontendPlugin } from '@backstage/frontend-plugin-api';

export const mcpChatFeatureFlagPlugin = createFrontendPlugin({
  pluginId: 'mcp-chat-flags',
  featureFlags: [
    {
      name: 'mcp-chat',
      description: 'Shows the AI Chat (Claude) item in the sidebar',
    },
  ],
});
